require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-kalina-wu-ivan-storck-and-sarah-fischer.json") })
        }
      }, "path---blog-author-kalina-wu-ivan-storck-and-sarah-fischer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-kalina-wu-ivan-storck-and-sarah-fischer!./.cache/json/blog-author-kalina-wu-ivan-storck-and-sarah-fischer.json
// module id = 664
// module chunks = 231608221292675